<template>
    <div class="row form my-5 ml-1">
        <div class="col-lg-12">
            <div class="row">
                <div class="col-sm-4 input-group pb-2 mb-4">
                    <div class="col-lg-12 px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <span>{{ $t('services.inventory.name') }}</span>
                            </div>
                            <div class="col-lg-5">
                                <input class="text-right" v-model="item.name" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 input-group pb-2 mb-4">
                    <div class="col-lg-12 px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <span>{{ $t('services.inventory.date') }}</span>
                            </div>
                            <div class="col-lg-5">
                                <core-calendar
                                    class="text-right"
                                    :date.sync="item.date"
                                ></core-calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 input-group pb-2 mb-4">
                    <div class="col-lg-12 px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <span>{{ $t('services.inventory.outbound') }}</span>
                            </div>
                            <div class="col-lg-5 text-right">
                                <core-lever labelClass="mr-0" v-model="outbound"></core-lever>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 input-group pb-2 mb-4">
                    <div class="col-lg-12 px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <span>{{ $t('services.inventory.time-period') }}</span>
                            </div>
                            <div class="col-lg-5 text-right">
                                <core-basic-drop-down
                                    :items="timePeriods"
                                    :selection.sync="item.transportTimePeriod"
                                    :simpleValue="false"
                                ></core-basic-drop-down>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <core-number-input
                    class="col-sm-4 px-3 pb-2 mb-4"
                    :label="$t('services.inventory.occupancy-alert')"
                    :amount.sync="item.occupancyAlert"
                    percentage
                ></core-number-input>
            </div>
            <div class="row">
                <core-lever
                    :label="$t('services.inventory.direct-tickets')"
                    labelPosition="right"
                    labelClass="ml-2"
                    v-model="directTickets"
                ></core-lever>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      item: this.inventory,
      outbound: this.inventory.returnJourney !== '1',
      directTickets: this.inventory.directTickets === '1'
    }
  },
  props: {
    inventory: {
      type: Object,
      required: true
    },
    transportTimePeriods: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  computed: {
    timePeriods () {
      let periods = []
      this.transportTimePeriods.forEach((period, index) => {
        this.$set(period, 'name_NL', 'Time: ' + (parseInt(index) + 1))
        periods.push(period)
      })
      return periods
    }
  },
  watch: {
    item: {
      handler (val) {
        this.$emit('update:inventory', val)
      },
      deep: true
    },
    outbound (val) {
      this.item.returnJourney = !val
    },
    directTickets (val) {
      this.item.directTickets = val
    }
  }
}
</script>

<style scoped>
    span >>> .vc-w-full {
        text-align: right;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/inventory/layout/BaseForm.vue